import { StringParam, useQueryParam } from "use-query-params";

export const TAX_HOME_TAB_PARAM_NAME = "tab";

export enum TaxCaseDetailsTab {
  DASHBOARD = "DASHBOARD",
  EXTERNAL_DOCUMENTS = "EXTERNAL_DOCUMENTS",
  BANK_STATEMENTS = "BANK_STATEMENTS",
  COMMENTS = "COMMENTS",
}

// The bank statements tab only exists from this tax year on.
export const BANK_STATEMENTS_TAB_FIRST_YEAR = 2025;

export const getBankStatementsLink = (email: string, taxYear: number) =>
  `/tax-declaration/tax-home?${new URLSearchParams({
    email,
    year: String(taxYear),
    [TAX_HOME_TAB_PARAM_NAME]: TaxCaseDetailsTab.BANK_STATEMENTS,
  }).toString()}`;

/** The tab named in the URL, if it is a tab that exists for this tax year. */
export const useInitialTaxCaseDetailsTab = (
  taxYear: number
): TaxCaseDetailsTab | undefined => {
  const [tab] = useQueryParam(TAX_HOME_TAB_PARAM_NAME, StringParam);

  if (!Object.values(TaxCaseDetailsTab).includes(tab as TaxCaseDetailsTab)) {
    return undefined;
  }
  if (
    tab === TaxCaseDetailsTab.BANK_STATEMENTS &&
    taxYear < BANK_STATEMENTS_TAB_FIRST_YEAR
  ) {
    return undefined;
  }
  return tab as TaxCaseDetailsTab;
};
